<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="update_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <path id="Path_8004" data-name="Path 8004" d="M0,0H18V18H0Z" fill="none" />
    <path id="Path_8005" data-name="Path 8005" d="M0,0H18V18H0Z" fill="none" />
    <g>
      <path
        id="Path_8006"
        data-name="Path 8006"
        d="M10,16h0a6,6,0,0,0,5.27-3.131M16,10h0a6,6,0,0,0-6-6m0,0h0A6,6,0,0,0,4.73,7.131M4,10H4a6,6,0,0,0,6,6"
        transform="translate(-1 -1)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8007"
        data-name="Path 8007"
        d="M4.73,7.131h0A6,6,0,0,1,16,10M4,10H4a6,6,0,0,0,11.271,2.867"
        transform="translate(-1 -0.999)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8008"
        data-name="Path 8008"
        d="M7.163,7.291H4.512V4.639"
        transform="translate(-1.128 -1.16)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8009"
        data-name="Path 8009"
        d="M15.953,15.825H18.6v2.652"
        transform="translate(-3.988 -3.956)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>
